var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 14.004"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13094",
    d: "M0 6.225h21.006v1.556H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7010",
    d: "M13.443 14v-1.9L20.398 7l-6.955-5.1V0L22 6.275v1.453l-8.555 6.273z"
  }))));
}
export default SvgArrowRight;